import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/gift.svg'
import _imports_1 from '@/assets/users-v2.svg'
import _imports_2 from '@/assets/user-v2.svg'
import _imports_3 from '@/assets/caret_down.svg'


const _hoisted_1 = { class: "max-w-[190px] w-full h-auto overflow-hidden" }
const _hoisted_2 = { class: "w-full rounded-[4px] m-[2px] mt-[1px] ml-[1px] py-4 px-3 bg-[#E5E4E2]" }
const _hoisted_3 = { class: "text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_4 = { class: "w-full flex flex-col items-start mt-2" }
const _hoisted_5 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem] pr-1" }
const _hoisted_6 = { class: "w-full h-[calc(100vh-155px)] overflow-y-auto rounded-[4px] m-[2px] mt-[1px] ml-[1px] pt-4 pb-2 px-3 bg-[#E5E4E2]" }
const _hoisted_7 = { class: "text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_8 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem]" }
const _hoisted_9 = { class: "w-full flex flex-col items-start" }
const _hoisted_10 = {
  src: _imports_2,
  alt: "Users"
}
const _hoisted_11 = {
  key: 0,
  src: _imports_3,
  alt: "Caret down"
}
const _hoisted_12 = {
  class: "-rotate-180",
  src: _imports_3,
  alt: "caret up"
}
const _hoisted_13 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem]" }
const _hoisted_14 = {
  key: 0,
  class: "mt-[3px] pl-4"
}
const _hoisted_15 = { class: "w-full flex flex-col gap-[2px] p-[2px] pl-[6px] border-l-[2px] border-[#D3D1CD]" }
const _hoisted_16 = ["id"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["id"]

import { useTranslate } from "@/composables/useTranslate";
import { InstallerDetails, Worker } from "@/types";
import { watch, nextTick, ref } from "vue";
import { useRoute } from "vue-router";

// Route
type Props = {
  workers?: Worker[];
  installerDetails?: InstallerDetails;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InstallersSidemenu',
  props: {
    workers: {},
    installerDetails: {}
  },
  setup(__props: any) {

const route = useRoute();
const { t } = useTranslate();

// Props
const props = __props;
const selectedWorker = ref<Worker | null>(null);

const isInstallerReportMenuOpen = ref<boolean>(true);

watch(
  () => route.params.reportId,
  async (newReportId) => {
    if (newReportId) {
      await nextTick();

      setTimeout(() => {
        const el = document.getElementById(newReportId as string);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  },
  { immediate: true }
);

watch(
  () => props.installerDetails?.bonusReports,
  async () => {
    await nextTick();
    setTimeout(() => {
      const el = document.getElementById(route.params.reportId as string);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  }
);

watch(
  () => route.params.id,
  async (newWorkerId) => {
    if (newWorkerId) {
      await nextTick();
      setTimeout(() => {
        const el = document.getElementById(newWorkerId as string);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  },
  { immediate: true }
);

// Automatically find the selected worker based on the route
watch(
  () => route.params.id,
  (newId: string | string[]) => {
    if (newId && props.workers?.length) {
      const foundWorker = props.workers?.find(
        (worker: Worker) => String(worker.id) === String(newId)
      );
      selectedWorker.value = foundWorker || null;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)("installers.reports")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          to: "/installers/monthly-bonus",
          class: _normalizeClass(["w-fit flex items-center gap-1 cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300", `${_unref(route).path.includes('monthly-bonus') ? 'bg-white' : ''} `])
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Gift"
            }, null, -1)),
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(t)("installers.monthly_bonus")), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(t)("installers.installers")), 1)
      ]),
      _createVNode(_component_RouterLink, {
        to: "/installers",
        class: _normalizeClass(["w-fit flex items-center gap-1 mt-2 mb-[2px] p-[6px] rounded-primary-radius cursor-pointer hover:bg-[#D3D1CD] duration-300", _unref(route).path === '/installers' ? 'bg-white' : 'bg-transparent'])
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "w-[15px] h-[15px]",
            src: _imports_1,
            alt: ""
          }, null, -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("installers.all_installers")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_9, [
        (selectedWorker.value && selectedWorker.value.id === _unref(route).params.id)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
            () => {
              if (!_unref(route).path.includes('report')) {
                isInstallerReportMenuOpen.value = !isInstallerReportMenuOpen.value;
              }
            }
          )
            }, [
              _createVNode(_component_RouterLink, {
                to: `/installers/${selectedWorker.value.id}`,
                class: "w-full flex items-center gap-1 cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                    [_vShow, _unref(route).params.id !== selectedWorker.value.id]
                  ]),
                  (
                _unref(route).params.id === selectedWorker.value.id &&
                !isInstallerReportMenuOpen.value
              )
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                    [_vShow, 
                _unref(route).params.id === selectedWorker.value.id &&
                isInstallerReportMenuOpen.value
              ]
                  ]),
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(selectedWorker.value.fullname), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              (
              _unref(route).params.id === selectedWorker.value.id && isInstallerReportMenuOpen.value
            )
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-full relative text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300", [
                  !_unref(route).params.reportId
                    ? 'bg-white before:absolute before:top-0 before:-left-2 before:h-full before:w-[2px] before:bg-[#51687A]'
                    : 'bg-transparent',
                ]]),
                        id: selectedWorker.value.id
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: `/installers/${selectedWorker.value.id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("installers.current_month")), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 10, _hoisted_16),
                      (__props.installerDetails && __props.installerDetails.bonusReports)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.installerDetails.bonusReports, (report) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: report.id,
                                class: _normalizeClass(["w-full relative text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300", [
                    report.id === Number(_unref(route).params.reportId)
                      ? 'bg-white before:absolute before:top-0 before:-left-2 before:h-full before:w-[2px] before:bg-[#51687A]'
                      : 'bg-transparent',
                  ]]),
                                id: String(report.id)
                              }, [
                                _createVNode(_component_RouterLink, {
                                  to: `/installers/${selectedWorker.value.id}/report/${report.id}`,
                                  class: "w-full flex items-start"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(report.month + " " + report.year), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ], 10, _hoisted_18))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})